import styled from 'styled-components';
import { rem } from 'polished';

export const StyledTestimonialsTable = styled.div`
  width: 100%;
  .slick-track {
    display: flex !important;
    align-items: stretch;
    padding-top: 0;
    margin-bottom: ${rem(`24px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      margin-bottom: 0;
    `}
  }
  .slick-slide {
    height: auto !important;
    display: flex !important;
    flex-direction: column;
  }
  .slide-item {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    padding: 0 ${rem(`6px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      padding: 0 ${rem(`14px`)};
    `}
  }
  .list-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .list {
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: dense;
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 12px;
    margin: ${rem(`24px`)} ${rem(`-6px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      margin: ${rem(`24px`)} ${rem(`-6px`)};
      grid-template-columns: repeat(2, 1fr);
      max-width: 100%;
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      margin: ${rem(`24px`)} ${rem(`-6px`)};
      grid-template-columns: repeat(2, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      margin: ${rem(`24px`)} ${rem(`-12px`)} ${rem(`48px`)};
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 24px;
    `}
  }
`;
